import env from '@upgrade/ui-utils/env';
import fetchJson from '@upgrade/ui-utils/api/fetch-json';
export default (function (defaults) {
  return function () {
    if (env.REACT_APP_OPTIMIZELY_ENDPOINT === '') {
      return Promise.resolve(defaults);
    }

    // we cache the request on the global scope to allow apps to preload the optimizely data during page load (before the
    // main JS bundle is loaded/executed), while also preventing double fetching the same resource.
    if (global.upgradeOptimizely && global.upgradeOptimizely.dataPromise) {
      return global.upgradeOptimizely.dataPromise;
    }
    var dataPromise = fetchJson({
      autoContentType: true,
      // omit 'Content-Type' header
      baseUrl: '',
      credentials: 'omit',
      includeCorrelationId: false,
      // omit 'X-CF-CORR-ID' header
      includeMobileHeaders: false,
      // omit mobile WebView headers
      url: env.REACT_APP_OPTIMIZELY_ENDPOINT
    }).then(function (_ref) {
      var error = _ref.error,
        data = _ref.data;
      return error ? defaults : data;
    });
    global.upgradeOptimizely = global.upgradeOptimizely || {};
    global.upgradeOptimizely.dataPromise = dataPromise;
    return dataPromise;
  };
});